class FocusTrap {
    _enabled = false;
    _currentTrap = null;
    /**
     * @param {object} _focusTrap
     * @param {(element:HTMLElement | string | [HTMLElement], options:object) => {}} _focusTrap.createFocusTrap
     */
    _focusTrap = null;
    /**
     * @param {object} _tabbable
     * @param {(element:HTMLElement | string | [HTMLElement]) => {}} _tabbable.isTabbable
     */
    _tabbable = null;

    /**
     * @param {object} config - the configuration settings
     * @param {boolean} config.enabled - if a Focus Trap will be activated
     * @param {object} [config.createOptions  = {}]- check documentation of the used library https://www.npmjs.com/package/focus-trap
     * @param {object} [config.activateOptions  = {}]- check documentation of the used library https://www.npmjs.com/package/focus-trap
     * @param {object} [config.deactivateOptions  = {}]- check documentation of the used library https://www.npmjs.com/package/focus-trap
     * @param {object} [config.initialFocus = {}] - custom set of the initialFocus element per container
     */
    constructor(config) {
        this.config = config;
        try {
            this._focusTrap = require('focus-trap');
            this._tabbable = require('tabbable');
            this._enabled = true;
        } catch (err) {
            console.error('Focus Trap Library not found:', err);
        }
    }

    async checkCanFocusTrap(containers) {
        return new Promise((resolve, reject) => {
            const container = containers[0];
            setTimeout(() => {
                if (container) {
                    resolve();
                }
            }, 100);
        });
    }
    disableBsTooltips() {
        try {
            setTimeout(() => {
                if (jQuery && !!document.body.querySelector('[role="tooltip"]')) {
                    $('[data-toggle="tooltip"]').tooltip('hide');
                }
            }, 100);
        } catch (err) {
            console.error('Failed to disableBsTooltips inside Focus Trap:', err);
        }
    }

    /**
     * @param {string} configSubset - which subset of options from the configuration should we take into account
     * @param {HTMLElement | string | [HTMLElement]} element - one or more "containers" of tabbable nodes that, together, form the total set of nodes that can be visited, with clicks or the tab key, within the trap
     * @param {object} [createOptions] check documentation https://www.npmjs.com/package/focus-trap
     * @param {boolean} [isIframe = false] - if the targeted element is inside an iframe
     */
    init(configSubset, element, createOptions = {}, isIframe = false) {
        if (this.config[configSubset].enabled) {
            try {
                this.deactivate();
                this.create(configSubset, element, createOptions, isIframe);
                this.activate();
            } catch (err) {
                console.error('Error initiating Focus Trap:', err, {configSubset, element, createOptions, isIframe});
            }
        }
    }

    /**
     * @param {string} configSubset - which subset of options from the configuration should we take into account
     * @param {HTMLElement | string} element - specify a different element to receive the initial focus
     */
    getCustomInitialFocus(configSubset, element) {
        const el = typeof element === 'string' ? doc.querySelector(element) : element;
        return this.config[configSubset].initialFocus?.[el.id];
    }

    /**
     * @param {HTMLElement | string} element - specify a different element to receive the initial focus
     */
    getFocusableInitialFocus(element) {
        if (this._tabbable.isTabbable(element)) {
            return element;
        }
        let focusableElements = this._tabbable.focusable(element);
        return focusableElements.length ? focusableElements[0] : null;
    }

    /**
     * @param {object} activateOptions check documentation https://www.npmjs.com/package/focus-trap#user-content-trapactivate
     */
    activate(activateOptions = {}) {
        try {
            this._currentTrap?.activate(activateOptions);
        } catch (err) {
            console.error('Failed to activate Focus Trap:', err, activateOptions);
        }
    }
    /**
     * @param {object} deactivateOptions check documentation https://www.npmjs.com/package/focus-trap#user-content-trapdeactivate
     */
    deactivate(deactivateOptions = {}) {
        try {
            this._currentTrap?.deactivate(deactivateOptions);
        } catch (err) {
            console.error('Failed to deactivate Focus Trap:', err, deactivateOptions);
        }
    }

    /**
     * @param {string} configSubset - which subset of options from the configuration should we take into account
     * @param {HTMLElement | string | [HTMLElement]} element - one or more "containers" of tabbable nodes that, together, form the total set of nodes that can be visited, with clicks or the tab key, within the trap
     * @param {object} [createOptions] check documentation https://www.npmjs.com/package/focus-trap
     * @param {boolean} [isIframe = false] - if the targeted element is inside an iframe
     */
    create(configSubset, element, createOptions = {}, isIframe = false) {
        try {
            this._currentTrap = this._focusTrap.createFocusTrap(element, {
                onDeactivate: this.disableBsTooltips.bind(this),
                ...this.config[configSubset]?.createOptions,
                ...createOptions,
                initialFocus:
                    (createOptions.initialFocus &&
                        element !== createOptions.initialFocus &&
                        this.getFocusableInitialFocus(createOptions.initialFocus)) ||
                    this.getCustomInitialFocus(configSubset, element),
                checkCanFocusTrap: isIframe && this.checkCanFocusTrap.bind(this),
            });
        } catch (err) {
            console.error('Failed to create Focus Trap:', err, createOptions);
        }
    }
}

module.exports = FocusTrap;
